"use client";

import React from "react";
import { Package } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
function DealsGrid() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <Card key={i} data-index={i} className="rounded-md border-border shadow-md">
            <div className="aspect-square animate-pulse bg-muted/50 rounded-t-md" />
            <CardContent className="p-5 space-y-3">
              <div className="h-4 w-1/3 animate-pulse bg-muted rounded" />
              <div className="h-6 w-3/4 animate-pulse bg-muted rounded" />
              <div className="h-6 w-1/2 animate-pulse bg-muted rounded" />
              <div className="h-10 w-full animate-pulse bg-muted rounded mt-4" />
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error || products.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Hiện tại chưa có dự án chuyển đổi số nào được hiển thị.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => {
      const originalPrice = product.price ? (product.price * 1.42).toFixed(2) : null;
      const categoryName = product.categories?.[0]?.name || "Công nghệ";
      return <Card key={product.id} data-index={i} className="group relative overflow-hidden rounded-md border-border bg-card shadow-md transition-all duration-300 hover:-translate-y-[6px] hover:shadow-xl">
            <Badge variant="destructive" className="absolute left-4 top-4 z-10 font-default font-semibold shadow-sm bg-primary text-primary-foreground">
              NUCETECH Innovation
            </Badge>

            <Link to={product.link} className="block">
              <div className="relative flex aspect-square items-center justify-center bg-muted/10 p-6">
                {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" /> : <div className="flex h-32 w-32 items-center justify-center rounded-md bg-primary/10 text-primary">
                    <Package className="h-16 w-16" />
                  </div>}
              </div>
            </Link>

            <CardContent className="p-5">
              <div className="mb-2 text-xs font-default font-bold uppercase tracking-widest text-ring">
                {categoryName}
              </div>
              
              <Link to={product.link}>
                <h3 className="font-default mb-3 line-clamp-2 text-lg font-extrabold text-foreground transition-colors group-hover:text-ring">
                  {product.title}
                </h3>
              </Link>

              <div className="mb-5 flex items-baseline gap-2">
                <span className="font-default text-sm font-medium text-muted-foreground line-clamp-3">
                  {product.short_description || "Giải pháp tư vấn và chuyển đổi số tiên tiến cho ngành xây dựng hiện đại."}
                </span>
              </div>

              <Button asChild className="w-full rounded-md bg-primary text-primary-foreground hover:bg-primary/90 shadow-md font-default font-bold">
                <Link to={product.link}>Xem chi tiết</Link>
              </Button>
            </CardContent>
          </Card>;
    })}
    </div>;
}
export default function WeeklyDeals() {
  const wp_query_params = {
    per_page: 4
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}